//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from "vue";
export default {
  props: {
    spec: {
      type: Object,
      required: true,
      "default": function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      innerStyles: {}
    };
  },
  computed: {
    cssClasses: function cssClasses() {
      // This panel will be nameless when used in predefined layout (e.g. page.body, list.header, etc.)
      this.spec.view = this.spec.view || "panels/responsive";
      return this.$classes();
    },
    componentName: function componentName() {
      return this.$href() ? "a" : "div";
    }
  },
  methods: {
    $ready: function $ready() {
      var align = null;

      switch (this.spec.align) {
        case "center":
          align = "center";
          break;

        case "right":
          align = "flex-end";
          break;

        default:
          align = "flex-start";
      }

      Vue.set(this.innerStyles, "align-items", align);
    },
    isColumn: function isColumn(item) {
      return item.view == "panels/column-v1";
    },
    viewKey: function viewKey(item, index) {
      // Use view name for key to avoid component reuse issue
      return "view".concat(index, "_").concat(item.view);
    }
  }
};